import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaPlus, FaSearch, FaUserFriends } from 'react-icons/fa';
import { MdDelete, MdEdit, MdClose } from 'react-icons/md';
import styles from "./vales.module.css";
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Swal from 'sweetalert2';
import WindowLayout from '../../utils/layout/windowsLayout';
import ModalVales from './valesModal';
import Select from 'react-select';



const customStyles = {
    headRow: {
        style: {
            minHeight: "40px",
            backgroundColor: "#046cc2",
            fontSize: "15px",
            color: "white",
        },
    },


};
export default function Vales(props) {
    const { windowSize } = useAuth();

    const [showModal, setShowModal] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [roles, setRoles] = useState([]);
    const [userEdit, setUserEdit] = useState(null);
    const [ofices, setOfices] = useState([]);
    const { estados, municipios, codigos } = useAuth();
    const [genders, setGenders] = useState([]);

    const [loadingTable, setLoadingTable] = useState(false);
    const [totalRows, setTotalRows] = useState(10);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [textSearch, setTextSearch] = useState("");

    const [textSearchPrev, setTextSearchPrev] = useState("");

    const [companieAll, setCompanieAll] = useState([]);
    const [companieSelect, setCompanieSelect] = useState(null);

    const [distribuidores, setDistribuidores] = useState([]);
    const [distribuidorSelect, setDistribuidorSelect] = useState(null);
    const [estatusAll, setEstatusAll] = useState([{
        value:1,
        label:"Asignado"
    },
    {
        value:2,
        label:"Por asignar"
    }]);
    const [estatusSelect, setEstatusSelect] = useState(null);

    
    



    const columns = [
        {
            name: '# Vale',
            selector: row => row.number,
        },
        {
            name: 'Monto',
            selector: row => `$ ${row.amount.toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`,
        },
        {
            name: 'Empresa',
            selector: row => row.distributorName,
            cell: (row) => {
                let search = companieAll.findIndex(item=>item.value === row.companiesCentralOfficeId)
                if (search !== -1) {
                    return (
                        <div>{companieAll[search].label}</div>
                    )
                }
                else {
                    return (
                        <div>NA</div>
                    )
                }

            },
        },
        {
            name: 'Distribuidor',
            selector: row => row.distributorName,
        },
        {
            name: 'Expiración',
            selector: row => row.dateExpiration.split("T")[0],
        },
        {
            name: 'Status',
            cell: (row) => {
                if (row.statusId == 1) {
                    return (
                        <span className="badge bg-success">Asignado</span>
                    )
                }
                else {
                    return (
                        <span className="badge bg-danger">Por Asignar</span>
                    )
                }

            },
        },
        {
            name: 'Acciones',
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        <button className='btn btn-sm btn-primary' onClick={() => { setUserEdit(row); setShowModal(true); }}><MdEdit /></button>&nbsp;
                        <button className='btn btn-sm btn-danger' onClick={() => handleDelete(row.number, row.id)}><MdDelete /></button>
                    </div>
                )
            },
        }
    ];

    const handleDelete = (userName, userId) => {
        Swal.fire({
            title: "¿Esta segur@ que desea eliminar el vale #" + userName + "?",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            denyButtonText: "Cancelar"
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {

                api(SERVICE.deteleVale + `?Id=${userId}`, {}, "DELETE")
                    .then((data) => {
                        handleUpdate();
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
        });

    }

    const handleUpdate = () => {
        setLoadingTable(true);
        let URL = SERVICE.getVoucher + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        if (textSearch != "") {
            URL = URL + `&TextSearch=${textSearch}`;
        }
        if (companieSelect != null) {
            URL = URL + `&CompaniesCentralOfficeId=${companieSelect.value}`;
        }
        if (distribuidorSelect != null) {
            URL = URL + `&distributorId=${distribuidorSelect.value}`;
        }
        if (estatusSelect != null) {
            URL = URL + `&statusId=${estatusSelect.value}`;
        }
        setTextSearchPrev(textSearch);
        setTextSearch("");
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push(element);
                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(()=>{
                setLoadingTable(false);
            })
    }
    const handleUpdateNosearch = () => {
        setLoadingTable(true);
        let URL = SERVICE.getVoucher + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push(element);
                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(()=>{
                setLoadingTable(false);
            })
    }
    // const handleUpdateRoles = () => {

    //     api(SERVICE.getRoles)
    //         .then((data) => {
    //             let arrayTemp = [];
    //             for (let index = 0; index < data.data.data.length; index++) {
    //                 const element = data.data.data[index];
    //                 arrayTemp.push({
    //                     id: element.id,
    //                     identifier: element.identifier,
    //                     description: element.description
    //                 })
    //             }
    //             setRoles(arrayTemp);
    //         })
    //         .catch((err) => {

    //         })
    // }
    const handleGetGenders = () => {
        api(SERVICE.getGenders)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description
                        });

                    }
                }
                setGenders(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetDistribuidores = () => {
        let URL = "/Distributors" + SERVICE.getPersonal;
        
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];

                        arrayTemp.push({
                            value: element.distributorId,
                            label: element.distributorName
                        });

                    }
                }
                setDistribuidores(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetCompanies = async () => {
        let URL = SERVICE.getCompaniegrid;
        let arrayTemp2 = [];
        await api(URL)
            .then(async (data) => {

                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        await api(SERVICE.getCompanieSuc + element.id)
                            .then((data) => {
                                if (data.data.data) {
                                    for (let index = 0; index < data.data.data.length; index++) {
                                        const sucursalCom = data.data.data[index];

                                        arrayTemp2.push({
                                            label: element.companyName + " - " + sucursalCom.centralOfficeName + " - " + sucursalCom.descriptionAddress,
                                            value: sucursalCom.id
                                        });
                                        console.log("arrayTemp2p", arrayTemp2);
                                    }
                                }
                            })
                            .catch((err) => {
                                console.log(err);
                            })

                    }

                }

            })
            .catch((err) => {
                console.log(err);
            })
        setCompanieAll(arrayTemp2);
    }
    useEffect(() => {
        handleGetCompanies();
        handleGetDistribuidores();
    }, [])
    useEffect(() => {
        handleUpdate();
    }, [page, perPage,distribuidorSelect,companieSelect,estatusSelect])
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePerRowsChange = (newPerPage) => {
        setPerPage(newPerPage);
    };
    return (
        <>
            <WindowLayout
                title="VALES"
                route={["Vales"]}
                icon={<FaUserFriends />}
            >
                <div className='paperContainer'>
                    <div style={{ display: "flex", justifyContent: "left" }}>
                       
                        <div className={styles.itemForm} style={{ width: "33%",zIndex:2 }}>
                            <label class="form-label">Empresa: </label>
                            <Select isClearable={true} options={companieAll} class="form-control" placeholder="Seleccione una Empresa" value={companieSelect} onChange={(e) => setCompanieSelect(e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%",zIndex:2 }}>
                            <label class="form-label">Distribuidor: </label>
                            <Select isClearable={true} options={distribuidores} class="form-control" placeholder="Seleccione un Distribuidor" value={distribuidorSelect} onChange={(e) => setDistribuidorSelect(e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%",zIndex:2 }}>
                            <label class="form-label">Estatus: </label>
                            <Select isClearable={true} options={estatusAll} class="form-control" placeholder="Seleccione un Distribuidor" value={estatusSelect} onChange={(e) => setEstatusSelect(e)} />
                        </div>

                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div class="input-group flex-nowrap" style={{ width: "33%", marginBottom: "10px", paddingRight: "20px",zIndex:1}}>
                            <input type="text" class="form-control" placeholder="# vale" value={textSearch} onChange={(e) => setTextSearch(e.target.value)} aria-describedby="addon-wrapping" />
                            <button className='btn btn-primary' onClick={handleUpdate}><FaSearch /></button>
                        </div>
                        <div className={styles.containerButtomTop}>
                            <button className='btn btn-sm btn-success' onClick={() => setShowModal(!showModal)}><FaPlus></FaPlus></button>
                        </div>
                    </div>
                    <div class="input-group flex-nowrap" style={{ marginBottom: "10px", width: "500px", display: "none" }}>
                        <input type="text" class="form-control" placeholder="Busqueda" value={textSearch} onChange={(e) => setTextSearch(e.target.value)} aria-describedby="addon-wrapping" />
                        <button className='btn btn-primary' onClick={handleUpdate}><FaSearch /></button>
                    </div>
                    <div class="input-group flex-nowrap containerSearchPrev" style={{ display: textSearchPrev !== "" ? "flex" : "none" }}>
                        <div class="badgeSearch">Buscando por: <b>{textSearchPrev}</b> </div><div onClick={() => {
                            setTextSearch("");
                            setTextSearchPrev("");
                            handleUpdateNosearch();
                        }} className='divCloseSearch'><MdClose></MdClose></div>
                    </div>
                    <DataTable
                        columns={columns}
                        data={dataTable}
                        customStyles={APP_OPTIONS.TABLE_SETTING}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={perPage}
                        paginationRowsPerPageOptions={[10, 20, 30, 50]}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        progressPending={loadingTable}
                        persistTableHead
                        fixedHeader
                        fixedHeaderScrollHeight="600px"
                        responsive
                    />

                </div>
            </WindowLayout>
            <ModalVales
                show={showModal}
                setShow={setShowModal}
                roles={roles}
                dataEdit={userEdit}
                setDataEdit={setUserEdit}
                estados={estados}
                municipios={municipios}
                codigos={codigos}
                handleUpdate={handleUpdate}
                genders={genders}
                companieAll={companieAll}
                distribuidores={distribuidores}
                estatusAll = {estatusAll}
                companieSelectM = {companieSelect}
                distribuidorSelectM = {distribuidorSelect}
                estatusSelectM = {estatusSelect}
            />
        </>
    );
} 